import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    height: 3,
    background: '#eee',
    position: 'relative',
    margin: '25px 0 8px',
    width: '100%',
  },
  span: {
    display: 'inline-block',
    background: theme.palette.secondary.main,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    width: 0
  },
  text: {
    fontFamily: 'Roboto',
    fontSize: 12
  }
}));

function ProgressBar(props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <span className={classes.span} style={{ width: props.progress + '%' }}></span>
    </div>
  );

}

export default ProgressBar;